import { useQuery } from "@tanstack/react-query";
import { faCirclePlus, faEllipsisH, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { DateRange } from '../../../../../components/common/DateRange';
import ReactDOM from 'react-dom';
import { GameProposalEstimateAPI } from "../../TestManagementApi"; // API 경로는 실제 프로젝트에 맞게 조정 필요
import LogoComponent from "../../AddTest/AddTestPhase4/components/LogoComponent";
import InvoiceDownload from "../../AddTest/AddTestPhase4/components/InvoiceDownload";

// 모달 스타일
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  max-width: 70%;
  max-height: 70%;
  overflow-y: auto;
  padding: 0.5% 0 0.5% 1%;
  position: relative;
`;

const ModalCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
`;


const ContentWrapper = styled.div`
  overflow-y: auto;
`;

const ContentBox = styled.div`
  height: calc(85vh - 100px);
  background-color: white;
  box-shadow: 0px 24px 48px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  padding: 44px 40px 33px 40px;
  box-sizing: border-box;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextSpanBox = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #2282e9;
  line-height: 20px;
  margin-bottom: 22px;
`;

const ContentContainerWrapper = styled.div`
  display: flex;
  gap: 44px;
  height: calc(100% - 120px);
  overflow: hidden;
`;

const GrayBox = styled.div`
  background-color: #f8f9fa;
  padding: 33px 26px 35px 26px;
  border-radius: 3px;
  width: 496px;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow-y: auto;
`;

const GameInfoHeader = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const GrayBoxImg = styled.div<{ url?: string }>`
  width: 125px;
  height: 125px;
  border-radius: 5px;
  background-color: #c0c0c0;
  margin-right: 26px;
  background-image: ${props => props.url ? `url(${props.url})` : 'none'};
  background-size: cover;
  background-position: center;
`;

const GameInfoTable = styled.table`
  margin-top: -3%;
  width: 100%;
  border-collapse: collapse;
`;

const GameInfoRow = styled.tr`
font-size: 70%;
  &:last-child {
    border-bottom: none;
  }
`;

const GameInfoTitle = styled.td`
  width: 25%;
  padding: 10px 16px;
  color: #797979;
  background-color: #f8f8f8;
  font-weight: 400;
  vertical-align: middle;
  white-space: nowrap;
`;

const GameInfoContent = styled.td`
  width: 70%;
  font-weight: 500;
  padding: 10px 16px;
  vertical-align: middle;
  line-height: 1.4;
`;

const Table = styled.div`
  width: 660px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const TableTHead = styled.div`
  height: 35px;
  display: grid;
  grid-template-columns: 250fr 151fr 152fr 92fr;
  padding-left: 15px;
`;

const TableTHeadTd = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

const TBody = styled.div`
  flex: 1;
  border-top: 1.5px solid #add5ff;
  border-bottom: 1.5px solid #add5ff;
  margin-bottom: 18px;
  overflow-y: auto;
`;

const TableTBody = styled.div`
  border-bottom: 1px solid #ebf5ff;
  height: 50px;
  display: grid;
  grid-template-columns: 250fr 151fr 152fr 92fr;
  padding-left: 15px;
`;

const TableTBodyTd = styled.div`
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
`;

const PliMoneyContainer = styled.div`
  color: #2282e9;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  justify-content: end;
`;

const PliMoney = styled.div``;

// 견적서 모달 컴포넌트
export default function EstimateModal({ isOpen, onClose, gameProposalId }: { isOpen: boolean; onClose: () => void; gameProposalId: number }) {
    const { data: gameProposalEstimateData, isLoading } = useQuery({
        queryKey: ['gameProposalEstimate', gameProposalId],
        queryFn: async () => {
            const response = await GameProposalEstimateAPI(gameProposalId);
            return response.data;
        },
        // initialData: {
        //     "basicInfo": {
        //         "title": "GAME_TITLE",
        //         "companyName": "무모게임즈",
        //         "desiredTesterCount": 50,
        //         "platforms": ["PC", "MOBILE", "CONSOLE"],
        //         "rewards": 1500,
        //         "questionSource": "플리더스 추천 질문",
        //         "multipleChoiceQuestionCount": 5,
        //         "subjectiveQuestionCount": 4,
        //         "recruitDays": 10,
        //         "testDays": 11,
        //         "gameCategory": "CBT",
        //         "bannerUrl": "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png"
        //     },
        //     "pricingInfo": {
        //         "details": [{
        //             "service": "희망 테스트 유저 수",
        //             "count": 50,
        //             "unitPrice": 10,
        //             "totalPrice": 500
        //         }, {
        //             "service": "유저 지급 재화",
        //             "count": 50,
        //             "unitPrice": 1500,
        //             "totalPrice": 25000
        //         }, {
        //             "service": "객관식 질문 추가",
        //             "count": 1,
        //             "unitPrice": 20,
        //             "totalPrice": 20
        //         }, {
        //             "service": "주관식 질문 추가",
        //             "count": 1,
        //             "unitPrice": 30,
        //             "totalPrice": 30
        //         }],
        //         "totalPlimoney": 25550
        //     }
        // },

        // enabled: isOpen && !!gameProposalId
        enabled: true,
    });

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalCloseButton onClick={onClose}>×</ModalCloseButton>

                {isLoading ? (
                    <div>로딩 중...</div>
                ) : gameProposalEstimateData ? (
                    <ContentWrapper>
                        <ContentBox>
                            <TitleBox>
                                <div style={{ width: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                        <LogoComponent />
                                        <InvoiceDownload onClick={() => {
                                            console.log("invoice download 버튼 누름");
                                        }} />
                                    </div>
                                    <TextSpanBox>
                                        플리더스 테스트 제작소
                                        <br />
                                        Date {new Date().getFullYear()} . {String(new Date().getMonth() + 1).padStart(2, '0')} . {String(new Date().getDate()).padStart(2, '0')}
                                    </TextSpanBox>
                                </div>

                            </TitleBox>
                            <ContentContainerWrapper>
                                <GrayBox>
                                    <GameInfoHeader>
                                        <GrayBoxImg url={gameProposalEstimateData?.basicInfo.bannerUrl}></GrayBoxImg>
                                    </GameInfoHeader>
                                    <GameInfoTable>
                                        <tbody>
                                            <GameInfoRow>
                                                <GameInfoTitle>게임이름</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.title}</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>게임사</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.companyName}</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>모집기간</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.recruitDays}일</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>진행기간</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.testDays}일</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>희망 유저수</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.desiredTesterCount}명</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>게임 플랫폼</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.platforms.join(", ")}</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>게임 테스트 유형</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.gameTestType}</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>지급재화</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.rewards.toLocaleString()} 포인트</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>질문 유형</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.questionSource}</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>객관식 질문 수</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.multipleChoiceQuestionCount}개</GameInfoContent>
                                            </GameInfoRow>
                                            <GameInfoRow>
                                                <GameInfoTitle>주관식 질문 수</GameInfoTitle>
                                                <GameInfoContent>{gameProposalEstimateData?.basicInfo.subjectiveQuestionCount}개</GameInfoContent>
                                            </GameInfoRow>
                                        </tbody>
                                    </GameInfoTable>
                                </GrayBox>
                                <Table>
                                    <TableTHead>
                                        <TableTHeadTd>서비스</TableTHeadTd>
                                        <TableTHeadTd>갯수</TableTHeadTd>
                                        <TableTHeadTd>단가</TableTHeadTd>
                                        <TableTHeadTd>총합</TableTHeadTd>
                                    </TableTHead>
                                    <TBody>
                                        {gameProposalEstimateData?.pricingInfo.details.map((detail: any, index: number) => (
                                            <TableTBody key={index}>
                                                <TableTBodyTd>{index + 1}. {detail.service}</TableTBodyTd>
                                                <TableTBodyTd>{detail.count}</TableTBodyTd>
                                                <TableTBodyTd>{detail.unitPrice.toLocaleString()}</TableTBodyTd>
                                                <TableTBodyTd>{detail.totalPrice.toLocaleString()}</TableTBodyTd>
                                            </TableTBody>
                                        ))}
                                    </TBody>
                                    <PliMoneyContainer>
                                        <PliMoney style={{ marginRight: "57px" }}>총 견적</PliMoney>
                                        <PliMoney>{gameProposalEstimateData?.pricingInfo.totalPlimoney.toLocaleString()} 플리머니</PliMoney>
                                    </PliMoneyContainer>
                                </Table>
                            </ContentContainerWrapper>
                        </ContentBox>
                    </ContentWrapper>
                ) : (
                    <div>견적서 데이터를 불러올 수 없습니다.</div>
                )}
            </ModalContent>
        </ModalOverlay>,
        document.body
    );
};
